import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScreenOrderService } from '../Services/screen-order.service';
import { DeclarationService } from './declaration.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ExitModalComponent } from '../exit-modal/exit-modal.component';
import { DeclineModalComponent } from './decline-modal.component';
import { AccessibilityService } from '../Services/accessibility.service';
import { BallotService } from '../ballot/ballot.service';



@Component({
    selector: 'app-declaration',
    templateUrl: './declaration.component.html',
    styleUrls: ['./declaration.component.scss'],
    standalone: false
})
export class DeclarationComponent implements OnInit, AfterViewInit {

  declarationText: string
  agreeChecked: boolean = false
  declineChecked: boolean = false
  declineModalIsOpen = new BehaviorSubject(false)
  agreeFocused: boolean = false
  declineFocused: boolean = false
  isFocused: boolean = false
  routeName = ""
  status: string = ""
  ovalOnRight: boolean | undefined

  constructor(
    private readonly ballotService: BallotService,
    private readonly screenOrderService: ScreenOrderService,
    private readonly router: Router,
    private readonly declarationService: DeclarationService,
    private readonly dialog: MatDialog,
    private accessibilityService: AccessibilityService,
    private route: ActivatedRoute,
  ) {
    this.declarationText = declarationService.text
  }

  ngOnInit() {
    const ballot = this.ballotService.getBallot()
    if (ballot) {
      this.ovalOnRight = ballot.voteEventData.optionalEventConfiguration?.ovalOnRight ?? false;
    }

    this.route.queryParamMap.subscribe(params => {
      const routeStatus = params.get('status')

      if (routeStatus) {
        this.status = routeStatus
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.routeName = this.router.url.split('?')[0]
      this.resetFocus()
      this.accessibilityService.announceNavigation(this.status);
    }, 500);
  }

  resetFocus() {
    let focusField = document.getElementById('accessibility-button')
    let focusFieldMobile = document.getElementById('accessibility-button-mobile')

    if (focusField) {
      focusField.focus()
    }

    if (focusFieldMobile) {
      focusFieldMobile.focus()
    }
  }

  focusChoice(focusIndex: number) {
    if (focusIndex == 1) {
      this.agreeFocused = true
    }
    else if (focusIndex == 2) {
      this.declineFocused = true
    };
  }

  checkAgree() {
    this.agreeChecked = !this.agreeChecked;
    if (this.agreeChecked) {
      this.declineChecked = false
    }
  }
  onBlur(blurIndex: number) {
    if (blurIndex == 1) {
      this.agreeFocused = false
    }
    else if (blurIndex == 2) {
      this.declineFocused = false
    };

  }

  checkDecline() {
    this.declineChecked = !this.declineChecked;
    if (this.declineChecked) {
      this.agreeChecked = false
    }
  }

  exit(): void {
    this.dialog.open(ExitModalComponent)
  }

  next(): void {
    if (this.agreeChecked) {
      this.router.navigate(this.screenOrderService.nextRoute('declaration'));
      return
    }
    if (this.declineChecked) {
      this.dialog.open(DeclineModalComponent)
    }
  }
}
